import React, { ComponentProps } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as styles from "./styles";

type LabelProps = ComponentProps<typeof LabelPrimitive.Root>;

export const Label = (props: LabelProps) => (
  <LabelPrimitive.Root className={styles.container} {...props} />
);
